var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex justify-center align-center" }, [
    _c(
      "button",
      {
        staticClass: "ms-sign-in-btn",
        attrs: { type: "button" },
        on: { click: _vm.handleSignIn }
      },
      [
        _c(
          "svg",
          {
            staticClass: "ms-sign-in-btn__logo",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "21",
              height: "21",
              viewBox: "0 0 21 21"
            }
          },
          [
            _c("rect", {
              attrs: {
                x: "1",
                y: "1",
                width: "9",
                height: "9",
                fill: "#f25022"
              }
            }),
            _c("rect", {
              attrs: {
                x: "1",
                y: "11",
                width: "9",
                height: "9",
                fill: "#00a4ef"
              }
            }),
            _c("rect", {
              attrs: {
                x: "11",
                y: "1",
                width: "9",
                height: "9",
                fill: "#7fba00"
              }
            }),
            _c("rect", {
              attrs: {
                x: "11",
                y: "11",
                width: "9",
                height: "9",
                fill: "#ffb900"
              }
            })
          ]
        ),
        _c("span", { staticClass: "ms-sign-in-btn__text" }, [
          _vm._v(
            _vm._s(
              _vm.signup
                ? _vm.$t("mfa.signUpMicrosoft")
                : _vm.$t("mfa.signInMicrosoft")
            )
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }